import { JsonHubProtocol } from "@microsoft/signalr";
import { getJwt } from "./../services/accountService";
import { useHistory } from "react-router";
import { HOMEPAGE } from "./../navigation/Constants";

const MESSAGE_BOX_SCROLL_DURATION = 400;

declare global {
  interface Window {
    messageHandler: {
      postMessage(msg: string): void;
    };
    platform: string;
    uploads: {
      base64image: string;
    };
  }
}

export const convertBase64ToBlob = (base64Image: any) => {
  // Split into two parts
  const parts = base64Image.split(";base64,");

  // Hold the content type
  const imageType = parts[0].split(":")[1];

  // Decode Base64 string
  const decodedData = window.atob(parts[1]);

  // Create UNIT8ARRAY of size same as row data length
  const uInt8Array = new Uint8Array(decodedData.length);

  // Insert all character code into uInt8Array
  for (let i = 0; i < decodedData.length; ++i) {
    uInt8Array[i] = decodedData.charCodeAt(i);
  }

  // Return BLOB image after conversion
  return new Blob([uInt8Array], { type: imageType });
};

function sinEaseOut(timestamp: any, begining: any, change: any, duration: any) {
  return (
    change *
      ((timestamp = timestamp / duration - 1) * timestamp * timestamp + 1) +
    begining
  );
}

/**
 *
 * @param {*} target scroll target
 * @param {*} scrollStart
 * @param {*} scroll scroll distance
 */
function scrollWithSlowMotion(target: any, scrollStart: any, scroll: number) {
  const raf = window?.requestAnimationFrame;
  let start = 0;
  const step = (timestamp: any) => {
    if (!start) {
      start = timestamp;
    }
    let stepScroll = sinEaseOut(
      timestamp - start,
      0,
      scroll,
      MESSAGE_BOX_SCROLL_DURATION
    );
    let total = scrollStart + stepScroll;
    target.scrollTop = total;
    if (total < scrollStart + scroll) {
      raf(step);
    }
  };
  raf(step);
}

export function scrollToBottom(messagesDiv: HTMLDivElement | null) {
  if (!messagesDiv) return;
  const screenHeight = messagesDiv.clientHeight;
  const scrollTop = messagesDiv.scrollTop;
  const scrollOffset = messagesDiv.scrollHeight - (scrollTop + screenHeight);
  if (scrollOffset) scrollWithSlowMotion(messagesDiv, scrollTop, scrollOffset);
}

export function hideDropdownToggle(id: string) {
  let element = document.getElementById(id);
  element?.dispatchEvent(new Event("w-close", { bubbles: true }));
}

export const addModalNavigation = (value: string) => {
  const data: any = localStorage.getItem("modalOpen");
  let modal = {};
  if (data) {
    let values = JSON.parse(data);
    modal = {
      name: [...values.name, value],
    };
  } else {
    modal = {
      name: [value],
    };
  }
  localStorage.setItem("modalOpen", JSON.stringify(modal));
};

export function subStrConversionMessage(message: string) {
  if (message) {
    let maxLength = 6;
    let messageParts = message.split(" ");
    if (messageParts.length > maxLength || message.length > 35) {
      let newParts = messageParts.slice(0, maxLength);
      return [...newParts, "..."].join(" ");
    }
  }
  return message;
}

export function getUserAndRedirect(history: any) {
  const getUser = getJwt();
  if (getUser) history.replace(HOMEPAGE);
}

export function sendMessageToWebViewWrapper(data: any) {
  if (window.messageHandler) {
    window.messageHandler.postMessage(JSON.stringify(data));
  }
}

export function androidOrIOS() {
  const userAgent = navigator.userAgent;
  if (/android/i.test(userAgent)) {
    return "android";
  }
  if (/iPad|iPhone|iPod/i.test(userAgent)) {
    return "ios";
  }
  // if (/chrome/i.test(userAgent)) {
  //     return 'chrome';
  // }
}
